// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__NOaLN","title":"FrontImage_title__2Tdu3"};